import { ICreateGestaoDistribuicaoEpiUseCase } from "../../../presentation/useCases/create/create_gestao_distribuicao_epi_use_case";
import { IGestaoEpiRepository } from "../../repositories/gestao_epi_repository";


export class CreateGestaoDistribuicaoEpiUseCase implements ICreateGestaoDistribuicaoEpiUseCase {
  constructor(private readonly repository: IGestaoEpiRepository) { }

  async createGestaoDistribuicaoEpi(
    itens: { idGestaoRecebimentoEpi: number; quantidade: number }[],
    idFuncionario: number | null,
    dataEntrega: Date | null,
    idCentroCustoSaida?: number | null,
    idCentroCusto?: number | null,
  ): Promise<number> {
    return await this.repository.createGestaoDistribuicaoEpi(
      itens,
      idFuncionario,
      dataEntrega,
      idCentroCustoSaida,
      idCentroCusto
    );
  }
}
